import { gql, useQuery } from '@apollo/client';
import {
  TRANSLATED_STRING_FIELDS,
  translateBackend,
} from '@assets/i18n/config';
import { useParams } from 'react-router-dom';

const FETCH_DASHBOARD = gql`
  query fetchOrganizationDashboard($dashboardId: ObjectID!) {
    fetchOrganizationDashboard(dashboardId: $dashboardId) {
      dashboard {
        id
        translatedName { ${TRANSLATED_STRING_FIELDS} }
      }
    }
  }
`;

export function DashboardBreadcrumb() {
  const { dashboardId } = useParams();

  const { data } = useQuery(FETCH_DASHBOARD, {
    variables: { dashboardId },
  });

  return data
    ? translateBackend(
        data.fetchOrganizationDashboard?.dashboard.translatedName,
      )
    : 'Dashboard';
}
